// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error {
  position: absolute;
  white-space: nowrap;
  max-height: 1.4em;
  top: 1.5em;
  font-weight: 400;
  font-size: 0.9em;
  color: rgba(124, 35, 35, 0.593);
}
.error__date {
  margin-left: 0;
}
.error__hidden {
  z-index: -1000;
  margin-top: -4px;
}
.error_dateInp {
  top: 2em;
}

input {
  color: #426ba6;
  padding: 1px 0.5em;
  background: transparent;
  border: 0;
  border-bottom: 1px solid #e2e2e2;
  font-style: italic;
  font-weight: 400;
}
input::placeholder {
  color: #a3b9d9;
}
input:focus {
  outline: none;
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.country_btn {
  border: 0;
  background: transparent;
}
.country_btn:hover {
  background: transparent;
}

.project_input {
  display: flex;
  padding-top: 5px;
  position: relative;
}
.project_input.column {
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.project_input.phoneInput .form-control {
  height: 1.3em;
  font-size: 1rem;
}
.project_input .react-tel-input .flag-dropdown {
  border: 0;
}
.project_input .react-tel-input .flag-dropdown:hover {
  background: transparent;
}
.project_input .inputSelect {
  position: absolute;
  list-style: none;
  padding: 0;
  background-color: rgba(255, 255, 255, 0.9215686275);
  z-index: 2;
  max-height: 500px;
  max-width: 300px;
  overflow: auto;
}
.project_input .inputSelect li {
  padding: 5px;
  width: 150px;
}
.project_input .inputSelect li:hover {
  background-color: rgba(214, 223, 234, 0.5764705882);
  cursor: pointer;
}
.project_input label {
  text-align: left;
  min-width: 7em;
}
.project_input input {
  width: 100%;
  height: 1.3em;
  font-size: 1em;
  box-sizing: border-box;
  padding-left: 0.5em;
}
.project_input .select__list_button {
  cursor: pointer;
}
.project_input .select__list_container {
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  z-index: 300;
}
.project_input .select__list {
  position: absolute;
  background: rgb(255, 255, 255);
  opacity: 100%;
  border: 1px solid #8aa1c1;
  width: max-content;
  min-width: 100%;
  right: 0;
  top: 1.1em;
  padding: 0 0;
  z-index: 300;
  box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;
}
.project_input .select__list ul {
  background-color: #fff;
  margin: 0 0;
  max-height: 10em;
  overflow-y: auto;
  overflow-x: hidden;
  list-style: none;
  padding: 0 0;
  text-align: left;
  padding-bottom: 0.8em;
  padding-top: 0.3em;
}
.project_input .select__list ul li {
  padding: 0.35em 0;
  padding-right: 0.35em;
  padding-left: 0.3em;
  font-weight: 400;
  border-bottom: 1px solid rgba(71, 74, 78, 0.0941176471);
  cursor: pointer;
}
.project_input .select__list ul li:last-child {
  border-bottom: 0;
}
.project_input .select__list ul li:hover {
  background-color: rgba(138, 161, 193, 0.1176470588);
}
.project_input.textereaInput {
  flex-direction: column;
  margin-top: 0;
  width: 100%;
}
.project_input.texterea_error textarea {
  border: 1px solid rgba(124, 35, 35, 0.593);
}

.left-drop .select__list {
  right: auto;
  left: 0;
}

textarea {
  resize: none;
  width: 330px;
  height: 100%;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
  font-style: italic;
  font-weight: 400;
  font-size: 1rem;
  color: #426ba6;
}
textarea:focus {
  outline: none;
  border: 1px solid rgba(39, 51, 110, 0.4274509804);
}
textarea[readOnly]:focus {
  outline: none;
  border: 1px solid rgba(163, 185, 217, 0.5960784314);
}

.textereaInput.texterea_error textarea {
  border: 1px solid rgba(124, 35, 35, 0.593);
  box-shadow: 0px 3px 10px 1px rgba(225, 126, 126, 0.5);
}
.textereaInput.texterea_error textarea::placeholder {
  color: rgba(124, 35, 35, 0.593);
  opacity: 1; /* Firefox */
}

.textArea_label {
  margin-bottom: 2px;
  white-space: nowrap;
}

.inputWithMeasureUnits {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.readOnly input:focus {
  outline: none;
  border-bottom: 1px solid #e2e2e2;
}

input[readOnly]:focus {
  outline: none;
  border-bottom: 1px solid #e2e2e2;
}

#questionImg {
  width: 1.2em;
  height: 1.2em;
  z-index: 99;
  display: block;
  position: relative;
}

.question {
  margin-left: 4px;
  position: relative;
  display: inline-block;
}
.question__dropdown {
  position: absolute;
  bottom: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  min-width: 100px;
  min-height: 10px;
  background-color: transparent;
  font-weight: 300;
  margin-left: -45px;
}
.question__dropdown p {
  padding: 0 5px;
  padding-bottom: 10px;
}

.procent {
  display: flex;
  align-items: flex-end;
  justify-content: right;
}
.procent:after {
  content: "%";
}

.price_input {
  display: flex;
  gap: 1em;
  align-items: center;
}

.project_input.date {
  display: flex;
  justify-content: center;
}

.datePicker_withText {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  gap: 5px;
}
.datePicker_withText input {
  color: #426ba6;
  z-index: 2;
  position: relative;
  text-align: center;
  padding: 0;
  background-color: rgba(255, 255, 255, 0);
}
.datePicker_withText input[type=date]::-webkit-calendar-picker-indicator {
  opacity: 0;
}
.datePicker_withText .datePicker_img_container {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgb(66, 107, 166);
  border-radius: 20%;
  background-color: white;
  height: 40px;
  width: 40px;
  box-sizing: content-box;
}
.datePicker_withText .datePicker_img_container.datePicker_error {
  border: 1px solid rgba(124, 35, 35, 0.593);
  box-shadow: 0px 3px 10px 2px rgba(191, 94, 94, 0.5);
}
.datePicker_withText .datePicker_img {
  width: 16px;
  height: 16px;
  z-index: 99;
  cursor: pointer;
}

.question-date {
  left: -1.5em;
  top: 0;
  z-index: 99;
  cursor: pointer;
  position: relative;
}

.miniLabel label {
  width: 10px;
}

.additional_inputs {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 1em;
}
.additional_inputs .project_input {
  min-width: 50px;
}
.additional_inputs label {
  width: auto;
}

.closeInput label {
  width: auto;
  margin-right: 0.5em;
}

.question__dropdown {
  font-size: smaller;
}

input[type=checkbox] {
  width: 1.2em;
  height: 1.2em;
}

.doc__input_selected {
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.selectedFormRef .ref_input {
  border-bottom: 1px solid rgba(29, 38, 82, 0.3921568627);
}

.autolabel .project_input label {
  min-width: auto;
  width: auto;
}

.project_input label.autolabel {
  min-width: auto;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/utilities/Inputs/utils/Inputs.scss","webpack://./src/Components/App/style/vars.scss"],"names":[],"mappings":"AAIA;EACE,kBAAA;EAEA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,+BAAA;AAJF;AAKE;EACE,cAAA;AAHJ;AAKE;EACE,cAAA;EACA,gBAAA;AAHJ;AAKE;EACE,QAAA;AAHJ;;AAOA;EACE,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAKE;EACE,cC9Be;AD2BnB;AAKE;EACE,aAAA;EACA,uDAAA;AAHJ;;AAMA;EACE,SAAA;EACA,uBAAA;AAHF;AAIE;EAEE,uBAAA;AAHJ;;AAOA;EACE,aAAA;EAIA,gBAAA;EACA,kBAAA;AAPF;AAQE;EACE,sBAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AASI;EACE,aAAA;EACA,eAAA;AAPN;AAWE;EACE,SAAA;AATJ;AAUI;EAEE,uBAAA;AATN;AAaE;EACE,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mDCjEiB;EDmEjB,UAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAZJ;AAcI;EACE,YAAA;EACA,YAAA;AAZN;AAcM;EACE,mDC5EkB;ED6ElB,eAAA;AAZR;AAiBE;EACE,gBAAA;EAIA,cAAA;AAlBJ;AAqBE;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AAnBJ;AAuBI;EACE,eAAA;AArBN;AAuBI;EAEE,WAAA;EAEA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAvBN;AAyBI;EACE,kBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EAEA,kBAAA;EACA,eAAA;EACA,QAAA;EAEA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iFAAA;AAzBN;AA2BM;EACE,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;AAzBR;AA2BQ;EACE,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;EAEA,uDAAA;EACA,eAAA;AA1BV;AA2BU;EACE,gBAAA;AAzBZ;AA2BU;EAEE,mDAAA;AA1BZ;AAiCE;EACE,sBAAA;EACA,aAAA;EAEA,WAAA;AAhCJ;AAmCI;EACE,0CAAA;AAjCN;;AAsCE;EACE,WAAA;EACA,OAAA;AAnCJ;;AAsCA;EACE,YAAA;EACA,YAAA;EACA,YAAA;EACA,mDAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EAGA,cAAA;AArCF;AAsCE;EACE,aAAA;EACA,iDAAA;AApCJ;AAuCI;EACE,aAAA;EACA,mDAAA;AArCN;;AA2CI;EACE,0CAAA;EAKA,qDAAA;AA5CN;AAwCM;EACE,+BAAA;EACA,UAAA,EAAA,YAAA;AAtCR;;AA6CA;EACE,kBAAA;EACA,mBAAA;AA1CF;;AA4CA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;AAzCF;;AA8CI;EACE,aAAA;EACA,gCAAA;AA3CN;;AAgDE;EACE,aAAA;EACA,gCAAA;AA7CJ;;AAiDA;EACE,YAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AA9CF;;AAgDA;EACE,gBAAA;EACA,kBAAA;EACA,qBAAA;AA7CF;AA+CE;EACE,kBAAA;EACA,YAAA;EACA,yDA1QK;EA2QL,4BAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;AA7CJ;AA8CI;EACE,cAAA;EACA,oBAAA;AA5CN;;AAiDA;EACE,aAAA;EACA,qBAAA;EACA,sBAAA;AA9CF;AAmDE;EAIE,YAAA;AApDJ;;AAwDA;EACE,aAAA;EAGA,QAAA;EAEA,mBAAA;AAxDF;;AA4DE;EACE,aAAA;EACA,uBAAA;AAzDJ;;AA6DA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,YAAA;EACA,QAAA;AA1DF;AA6DE;EAGE,cAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EAGA,UAAA;EAEA,wCAAA;AAhEJ;AAsEE;EACE,UAAA;AApEJ;AAuEE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;AArEJ;AAsEI;EACE,0CAAA;EACA,mDAAA;AApEN;AAuEE;EAIE,WAAA;EACA,YAAA;EAEA,WAAA;EACA,eAAA;AAzEJ;;AA8EA;EACE,YAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AA3EF;;AA+EE;EACE,WAAA;AA5EJ;;AA+EA;EACE,aAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;AA5EF;AA8EE;EACE,eAAA;AA5EJ;AAgFE;EACE,WAAA;AA9EJ;;AAkFE;EACE,WAAA;EACA,mBAAA;AA/EJ;;AAkFA;EACE,kBAAA;AA/EF;;AAkFA;EACE,YAAA;EACA,aAAA;AA/EF;;AAkFA;EAEE,uDAAA;AAhFF;;AAuFE;EACE,uDAAA;AApFJ;;AAyFE;EACE,eAAA;EACA,WAAA;AAtFJ;;AA2FE;EACE,eAAA;EACA,WAAA;AAxFJ","sourcesContent":["@import \"../../../Components/App/style/vars.scss\";\n// @import \"../../App/mixins.scss\";\n\n$bg-img: url(\"./info.png\");\n.error {\n  position: absolute;\n  // width: 100%;\n  white-space: nowrap;\n  max-height: 1.4em;\n  top: 1.5em;\n  font-weight: 400;\n  font-size: 0.9em;\n  color: rgba(124, 35, 35, 0.593);\n  &__date {\n    margin-left: 0;\n  }\n  &__hidden {\n    z-index: -1000;\n    margin-top: -4px;\n  }\n  &_dateInp {\n    top: 2em;\n  }\n}\n\ninput {\n  color: #426ba6;\n  padding: 1px 0.5em;\n  background: transparent;\n  border: 0;\n  border-bottom: 1px solid #e2e2e2;\n  font-style: italic;\n  font-weight: 400;\n  &::placeholder {\n    color: $placeholderColor;\n  }\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid #1d265264;\n  }\n}\n.country_btn {\n  border: 0;\n  background: transparent;\n  &:hover {\n    // font-weight: 500;\n    background: transparent;\n  }\n}\n\n.project_input {\n  display: flex;\n  // align-items: flex-start;\n  // justify-content: left;\n\n  padding-top: 5px;\n  position: relative;\n  &.column {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n  &.phoneInput {\n    & .form-control {\n      height: 1.3em;\n      font-size: 1rem;\n    }\n  }\n\n  .react-tel-input .flag-dropdown {\n    border: 0;\n    &:hover {\n      // font-weight: 500;\n      background: transparent;\n    }\n  }\n\n  & .inputSelect {\n    position: absolute;\n    list-style: none;\n    padding: 0;\n    background-color: $inputSelectBgColor;\n    // @include border;\n    z-index: 2;\n    max-height: 500px;\n    max-width: 300px;\n    overflow: auto;\n\n    & li {\n      padding: 5px;\n      width: 150px;\n\n      &:hover {\n        background-color: $inputSelectHoverBgColor;\n        cursor: pointer;\n      }\n    }\n  }\n\n  label {\n    text-align: left;\n    // margin-top: 5px;\n    // margin-right: 5px;\n\n    min-width: 7em;\n  }\n\n  input {\n    width: 100%;\n    height: 1.3em;\n    font-size: 1em;\n    box-sizing: border-box;\n    padding-left: 0.5em;\n  }\n\n  .select {\n    &__list_button {\n      cursor: pointer;\n    }\n    &__list_container {\n      // width: 25%;\n      width: 100%;\n      // width: calc(100% + 3em);\n      height: 100%;\n      display: flex;\n      position: absolute;\n      z-index: 300;\n    }\n    &__list {\n      position: absolute;\n      background: rgb(255, 255, 255);\n      opacity: 100%;\n      border: 1px solid #8aa1c1;\n      // min-width: 60%;\n      width: max-content;\n      min-width: 100%;\n      right: 0;\n      // width: calc(100% + 3em);\n      top: 1.1em;\n      padding: 0 0;\n      z-index: 300;\n      box-shadow: rgba(0, 0, 0, 0.118) 0px 19px 38px, rgba(0, 0, 0, 0.09) 0px 15px 12px;\n\n      ul {\n        background-color: #fff;\n        margin: 0 0;\n        max-height: 10em;\n        overflow-y: auto;\n        overflow-x: hidden;\n        list-style: none;\n        padding: 0 0;\n        text-align: left;\n        padding-bottom: 0.8em;\n        padding-top: 0.3em;\n\n        li {\n          padding: 0.35em 0;\n          padding-right: 0.35em;\n          padding-left: 0.3em;\n          font-weight: 400;\n          // margin-top: 0.3em;\n          border-bottom: 1px solid #474a4e18;\n          cursor: pointer;\n          &:last-child {\n            border-bottom: 0;\n          }\n          &:hover {\n            // font-weight: 500;\n            background-color: #8aa1c11e;\n          }\n        }\n      }\n    }\n  }\n\n  &.textereaInput {\n    flex-direction: column;\n    margin-top: 0;\n    // height: 70px;\n    width: 100%;\n  }\n  &.texterea_error {\n    textarea {\n      border: 1px solid rgba(124, 35, 35, 0.593);\n    }\n  }\n}\n.left-drop {\n  .select__list {\n    right: auto;\n    left: 0;\n  }\n}\ntextarea {\n  resize: none;\n  width: 330px;\n  height: 100%;\n  border: 1px solid #a3b9d998;\n  font-style: italic;\n  font-weight: 400;\n  font-size: 1rem;\n  // font-size: 0.9em;\n  // line-height: 13px;\n  color: #426ba6;\n  &:focus {\n    outline: none;\n    border: 1px solid #27336e6d;\n  }\n  &[readOnly] {\n    &:focus {\n      outline: none;\n      border: 1px solid #a3b9d998;\n    }\n  }\n}\n.textereaInput {\n  &.texterea_error {\n    textarea {\n      border: 1px solid rgba(124, 35, 35, 0.593);\n      &::placeholder {\n        color: rgba(124, 35, 35, 0.593);\n        opacity: 1; /* Firefox */\n      }\n      box-shadow: 0px 3px 10px 1px rgba(225, 126, 126, 0.5);\n    }\n  }\n}\n\n.textArea_label {\n  margin-bottom: 2px;\n  white-space: nowrap;\n}\n.inputWithMeasureUnits {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  width: 100%;\n}\n\n.readOnly {\n  input {\n    &:focus {\n      outline: none;\n      border-bottom: 1px solid #e2e2e2;\n    }\n  }\n}\ninput[readOnly] {\n  &:focus {\n    outline: none;\n    border-bottom: 1px solid #e2e2e2;\n  }\n}\n\n#questionImg {\n  width: 1.2em;\n  height: 1.2em;\n  z-index: 99;\n  display: block;\n  position: relative;\n}\n.question {\n  margin-left: 4px;\n  position: relative;\n  display: inline-block;\n\n  &__dropdown {\n    position: absolute;\n    bottom: 20px;\n    background-image: $bg-img;\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n    min-width: 100px;\n    min-height: 10px;\n    background-color: transparent;\n    font-weight: 300;\n    margin-left: -45px;\n    p {\n      padding: 0 5px;\n      padding-bottom: 10px;\n    }\n  }\n}\n\n.procent {\n  display: flex;\n  align-items: flex-end;\n  justify-content: right;\n  // margin-left: 4px;\n  // position: relative;\n  // display: inline-block;\n  // position: relative;\n  &:after {\n    // margin-left: 4px;\n    // position: relative;\n    // display: inline-block;\n    content: \"%\";\n  }\n}\n\n.price_input {\n  display: flex;\n  //   flex-wrap: nowrap;\n\n  gap: 1em;\n  //   justify-content: space-between;\n  align-items: center;\n}\n\n.project_input {\n  &.date {\n    display: flex;\n    justify-content: center;\n  }\n}\n\n.datePicker_withText {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n  gap: 5px;\n  // width: 9em;\n  // width: 160px;\n  input {\n    // left: -100px;\n    // top: 0.3em;\n    color: #426ba6;\n    z-index: 2;\n    position: relative;\n    text-align: center;\n    // width: 100px;\n    // height: 15px;\n    padding: 0;\n    // border: 0;\n    background-color: rgba(255, 255, 255, 0);\n    // &:focus {\n    //     outline: none;\n    //     // border-bottom: 0;\n    // }\n  }\n  input[type=\"date\"]::-webkit-calendar-picker-indicator {\n    opacity: 0;\n    // cursor: pointer;\n  }\n  .datePicker_img_container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid rgba(66, 107, 166, 1);\n    border-radius: 20%;\n    background-color: white;\n    height: 40px;\n    width: 40px;\n    box-sizing: content-box;\n    &.datePicker_error {\n      border: 1px solid rgba(124, 35, 35, 0.593);\n      box-shadow: 0px 3px 10px 2px rgba(191, 94, 94, 0.5);\n    }\n  }\n  .datePicker_img {\n    // left: -1.5em;\n    // top: -0.3em;\n    // right: -0.4em;\n    width: 16px;\n    height: 16px;\n    // margin-bottom: 0.3em;\n    z-index: 99;\n    cursor: pointer;\n    // position: absolute;\n  }\n}\n\n.question-date {\n  left: -1.5em;\n  top: 0;\n  z-index: 99;\n  cursor: pointer;\n  position: relative;\n}\n\n.miniLabel {\n  label {\n    width: 10px;\n  }\n}\n.additional_inputs {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  gap: 1em;\n  // width: 100%;\n  .project_input {\n    min-width: 50px;\n    // max-width: 70px;\n  }\n\n  label {\n    width: auto;\n  }\n}\n.closeInput {\n  label {\n    width: auto;\n    margin-right: 0.5em;\n  }\n}\n.question__dropdown {\n  font-size: smaller;\n}\n\ninput[type=\"checkbox\"] {\n  width: 1.2em;\n  height: 1.2em;\n}\n\n.doc__input_selected {\n  // outline: none;\n  border-bottom: 1px solid #1d265264;\n  // background-color:#426ca619;\n  // background: linear-gradient( transparent, 70%, #426ca621);\n  // background: radial-gradient(at 30% 100%, #426ca621 30%, transparent 70%);\n}\n\n.selectedFormRef {\n  .ref_input {\n    border-bottom: 1px solid #1d265264;\n  }\n}\n\n.autolabel {\n  .project_input label {\n    min-width: auto;\n    width: auto;\n  }\n}\n\n.project_input {\n  label.autolabel {\n    min-width: auto;\n    width: auto;\n  }\n}\n","$border-thin: 1px solid #426ca65e;\n\n//colors\n$tableBgColor: #fff;\n$placeholderColor: #a3b9d9;\n$borderColor: #a3b9d9;\n$accentFilterColor: #ff8040;\n\n//fonts\n$baseFontSize: 16px;\n\n//sizes\n$baseHeight: 720;\n$baseWidth: 1190;\n$borderRadius: 5px;\n\n$inputSelectBgColor: #ffffffeb;\n$inputSelectHoverBgColor: #d6dfea93;\n\n//shadows\n$filterBtnBoxShadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n\n//// margins padding\n$windowPadding: 16px;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
